import React, { useEffect, useState, useRef } from "react";
import CustomPieChart from './CustomPieChart';
import { useLocation } from "react-router-dom";
import Navbar from '../../Company/About/Navbar';
import Hero from "../../Company/CompanyHome/Hero";
import Footer from '../../Company/About/Footer';
import { Container } from '@/components/ui/layout';
import { Card, CardContent } from '@/components/ui/card';
import { Heading, Text } from '@/components/ui/typography';
import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';
import { cn } from '@/lib/utils';
// import html2pdf from "html2pdf.js";
// import { useReactToPrint } from "react-to-print";
// import ReactToPrint from "react-to-print";
// import { usePDF } from 'react-to-pdf';
// import generatePDF from 'react-to-pdf';
// import { jsPDF } from "jspdf";
// import html2canvas from "html2canvas";

const Reports = () => {
    const location = useLocation();
    const { candidate, jobDetails } = location.state || {}; // Safely access ranking and jobDetails
    const [traitScores, setTraitScores] = useState([]);
    const reportRef = useRef();
    console.log(candidate);

//     const handleDownloadPDF = async () => {
//       const element = reportRef.current;
//       if (!element) return;
    
//       element.scrollIntoView({ behavior: "instant", block: "start" });
//       await new Promise((r) => setTimeout(r, 500));
//       await document.fonts.ready;
    
//       const canvas = await html2canvas(element, {
//         useCORS: true,
//         allowTaint: false,
//         scale: 2, // higher scale = better quality
//         backgroundColor: "#ffffff",
//         logging: true,
//       });
    
//       const imgData = canvas.toDataURL("image/png");
//       const pdf = new jsPDF("p", "mm", "a4");
    
//       const pageHeight = pdf.internal.pageSize.getHeight();
//       const imgProps = pdf.getImageProperties(imgData);
//       const pdfWidth = pdf.internal.pageSize.getWidth();
//       const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
    
//       const totalPages = Math.ceil(pdfHeight / pageHeight);
    
//       for (let i = 0; i < totalPages; i++) {
//         const position = i * pageHeight;
      
//         const pageCanvas = document.createElement("canvas");
//         pageCanvas.width = canvas.width;
//         pageCanvas.height = pageHeight * (canvas.width / pdf.internal.pageSize.getWidth());
      
//         const pageCtx = pageCanvas.getContext("2d");
//         pageCtx.drawImage(
//           canvas,
//           0, position,
//           canvas.width, pageCanvas.height,
//           0, 0,
//           canvas.width, pageCanvas.height
//         );
      
//         const pageData = pageCanvas.toDataURL("image/png");
//         if (i !== 0) pdf.addPage();
//         pdf.addImage(
//           pageData,
//           "PNG",
//           0,
//           0,
//           pdfWidth,
//           (pageCanvas.height * pdfWidth) / canvas.width
//         );
//       }
    
//       pdf.save("candidate-report.pdf");
//     };

//     const handleDownloadPDF2 = async () => {
//       const element = reportRef.current;
//       await new Promise((r) => setTimeout(r, 500));
//       await document.fonts.ready;
//       if (!element) return;
//       html2pdf().from(element).save("component.pdf");
//     };

//     const handleBrowserPrint = () => {
//       if (!reportRef.current) return;
    
//       const content = reportRef.current.innerHTML;
//       const printWindow = window.open('', '_blank', 'width=800,height=800');
    
//       printWindow.document.write(`
//         <html>
//           <head>
//             <title>Candidate Report</title>
//             <style>
              
// body {
//   margin: 0;
//   font-family: 'Inter', 'Segoe UI', sans-serif;
//   /* font-family: 'Segoe UI', sans-serif; */
//   background-color: #f5f7fa;
//   line-height: 1.6;
//   font-size: 15px;
// }

// .pdf-download-btn {
//   background-color: #2b6cb0;
//   color: white;
//   padding: 10px 18px;
//   font-size: 15px;
//   border: none;
//   border-radius: 6px;
//   cursor: pointer;
//   transition: background 0.3s ease;
// }
// .pdf-download-btn:hover {
//   background-color: #2c5282;
// }

// @media print {
//   .pdf-download-btn,
//   nav,
//   footer {
//     display: none !important;
//   }

//   .report-wrapper {
//     margin: 0;
//     padding: 0;
//     width: 100%;
//   }
// }

// .report-wrapper {
//   max-width: 1200px;
//   margin: auto;
//   padding: 24px;
//   background-color: #fff;
//   border-radius: 12px;
//   box-shadow: 0 4px 12px rgba(0,0,0,0.06);
// }

// .report-header {
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   margin-bottom: 32px;
//   border-bottom: 1px solid #eee;
//   padding-bottom: 16px;
// }

// .header-info h1 {
//   font-size: 26px;
//   margin-bottom: 6px;
// }

// .header-info h2 {
//   font-size: 16px;
//   color: #555;
//   font-weight: 500;
//   margin: 0;
// }

// .score-badge {
//   text-align: center;
// }

// .score {
//   width: 80px;
//   height: 80px;
//   background-color: #d6f5dd;
//   color: #2e7d32;
//   font-size: 22px;
//   font-weight: bold;
//   border-radius: 50%;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   margin: auto;
// }

// .badge {
//   background-color: #fff3cd;
//   color: #856404;
//   padding: 4px 10px;
//   border-radius: 6px;
//   font-size: 14px;
//   margin-top: 6px;
//   display: inline-block;
// }

// .report-content {
//   display: flex;
//   flex-direction: column;
//   gap: 32px;
// }

// /* Summary Section */
// .section-card {
//   background: #fff;
//   padding: 20px;
//   border-radius: 10px;
//   box-shadow: 0 1px 4px rgba(0,0,0,0.06);
// }

// .section-card h3 {
//   margin-bottom: 12px;
// }

// .section-card.two-col {
//   display: flex;
//   justify-content: space-between;
//   gap: 24px;
//   align-items: flex-start;
// }

// .summary-block {
//   min-width: 240px;
//   padding: 16px 20px;
//   background: linear-gradient(145deg, #f9f9f9, #ffffff);
//   border: 1px solid #e2e8f0;
//   border-radius: 12px;
//   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
//   font-size: 14.5px;
// }

// .summary-block:hover {
//   box-shadow: 0 8px 24px rgba(60, 72, 88, 0.12);
//   transform: translateY(-4px);
// }

// .summary-item {
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   margin-bottom: 12px;
//   padding-bottom: 6px;
//   border-bottom: 1px dashed #ccc;
//   color: #333;
// }

// .summary-item:last-child {
//   border-bottom: none;
//   margin-bottom: 0;
// }

// .summary-item .label {
//   font-weight: 600;
//   color: #2b3d55;
//   letter-spacing: 0.3px;
// }


// .label {
//   font-weight: 500;
//   color: #666;
// }

// /* Grid Layouts */
// .grid.two-col,
// .grid.three-col {
//   display: grid;
//   gap: 24px;
// }

// .grid.two-col {
//   grid-template-columns: repeat(2, 1fr);
// }

// .grid.three-col {
//   grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
// }

// /* Cards: Strengths, Weaknesses, Recommendations */
// .highlight-card {
//   padding: 16px;
//   border-radius: 10px;
//   background: #fdfdfd;
//   box-shadow: 0 1px 4px rgba(0,0,0,0.06);
// }

// .highlight-card.success {
//   border-left: 6px solid #4caf50;
// }

// .highlight-card.danger {
//   border-left: 6px solid #f44336;
// }

// .highlight-card.neutral {
//   border-left: 6px solid #6200ea;
// }

// .highlight-card h4 {
//   margin-top: 0;
// }

// .highlight-card ul {
//   margin: 0;
//   padding-left: 20px;
// }

// /* Skills Row */
// .skill-row {
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
//   gap: 20px;
//   margin-top: 12px;
// }

// .skill-row div {
//   background: #f9f9f9;
//   padding: 12px 16px;
//   border-radius: 8px;
//   box-shadow: inset 0 0 2px rgba(0,0,0,0.05);
// }

// .skill-row strong {
//   display: block;
//   margin-bottom: 6px;
//   font-weight: 600;
// }

// .ai-recommendation-box {
//   margin-top: 20px;
//   padding: 16px;
//   border-left: 4px solid #4caf50;
//   background-color: #f0fdf4;
//   border-radius: 8px;
// }

// .ai-recommendation-box h4 {
//   margin-top: 0;
//   color: #2e7d32;
// }

// .skill-rating {
//   display: flex;
//   align-items: center;
//   gap: 8px;
//   margin: 6px 0;
// }

// .skill-rating .bar {
//   flex: 1;
//   height: 8px;
//   border-radius: 4px;
//   background-color: #e0e0e0;
//   position: relative;
//   overflow: hidden;
// }

// .skill-rating .bar-fill {
//   height: 100%;
//   background-color: #4caf50;
//   border-radius: 4px;
// }

// .skill-rating .score-value {
//   font-weight: 600;
//   font-size: 13px;
//   color: #333;
//   min-width: 42px;
// }

// /* AI Breakdown Chart Container */
// .ai-breakdown-container {
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   margin: 40px auto;
//   max-width: 1000px;
//   padding: 20px;
// }

// /* Title */
// .ai-breakdown-title {
//   font-size: 24px;
//   font-weight: 700;
//   text-align: center;
//   margin-bottom: 40px;
// }

// /* Pie chart and labels layout */
// .ai-chart-layout {
//   display: grid;
//   grid-template-columns: 1fr 300px 1fr;
//   grid-template-rows: 1fr 300px 1fr;
//   gap: 10px;
//   width: 100%;
//   position: relative;
// }

// /* Central Pie */
// .ai-pie {
//   grid-column: 2 / 3;
//   grid-row: 2 / 3;
//   align-self: center;
//   justify-self: center;
//   width: 280px;
//   height: 280px;
//   border-radius: 50%;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   background: conic-gradient(
//     #3f51b5 0% 20%,
//     #ffc107 20% 40%,
//     #f44336 40% 60%,
//     #4caf50 60% 80%,
//     #9c27b0 80% 100%
//   );
//   position: relative;
// }

// .ai-pie-text {
//   position: absolute;
//   font-size: 24px;
//   font-weight: bold;
//   color: #000;
// }

// /* Label card */
// .ai-label {
//   display: flex;
//   align-items: center;
//   gap: 10px;
//   padding: 8px;
//   max-width: 300px;
//   font-size: 14px;
//   position: relative;
// }

// .ai-label-icon {
//   width: 28px;
//   height: 28px;
//   border-radius: 50%;
//   display: inline-flex;
//   align-items: center;
//   justify-content: center;
//   color: #fff;
//   font-size: 14px;
// }

// .ai-label-line {
//   width: 50px;
//   height: 2px;
//   position: absolute;
//   top: 18px;
// }

// /* Each label section positioning */
// .ai-label-top-left {
//   grid-column: 1 / 2;
//   grid-row: 1 / 2;
//   justify-content: flex-end;
// }

// .ai-label-bottom-left {
//   grid-column: 1 / 2;
//   grid-row: 3 / 4;
//   justify-content: flex-end;
// }

// .ai-label-top-right {
//   grid-column: 3 / 4;
//   grid-row: 1 / 2;
// }

// .ai-label-bottom-right {
//   grid-column: 3 / 4;
//   grid-row: 3 / 4;
// }

// /* Line directions */
// .ai-label-top-left .ai-label-line {
//   background-color: #3f51b5;
//   right: -50px;
// }

// .ai-label-bottom-left .ai-label-line {
//   background-color: #f44336;
//   right: -50px;
// }

// .ai-label-top-right .ai-label-line {
//   background-color: #ffc107;
//   left: -50px;
// }

// .ai-label-bottom-right .ai-label-line {
//   background-color: #4caf50;
//   left: -50px;
// }

// /* Extra Center Right label */
// .ai-label-center-right {
//   grid-column: 3 / 4;
//   grid-row: 2 / 3;
//   align-self: center;
//   margin-left: 40px;
// }

// .ai-label-center-right .ai-label-line {
//   background-color: #9c27b0;
//   left: -50px;
// }


// .custom-table {
//   width: 100%;
//   border-collapse: collapse;
//   margin-top: 12px;
//   margin-bottom: 24px;
//   font-size: 14px;
//   background-color: #fff;
//   border: 1px solid #ddd;
//   border-radius: 8px;
//   overflow: hidden;
// }

// .custom-table thead {
//   background-color: #f5f7fa;
// }

// .custom-table th,
// .custom-table td {
//   padding: 10px 14px;
//   text-align: left;
//   border-bottom: 1px solid #eee;
// }

// .custom-table th {
//   font-weight: 600;
//   color: #333;
// }

// /* --- Card and Section Animations --- */
// @keyframes fadeInUp {
//   from {
//     opacity: 0;
//     transform: translateY(32px);
//   }
//   to {
//     opacity: 1;
//     transform: translateY(0);
//   }
// }

// .report-wrapper,
// .section-card,
// .highlight-card,
// .score-box,
// .custom-table {
//   animation: fadeInUp 0.7s cubic-bezier(.68,-0.55,.27,1.55) both;
//   /* Staggered animation for child elements */
// }

// .section-card:hover,
// .highlight-card:hover,
// .score-box:hover {
//   box-shadow: 0 8px 32px 0 rgba(60, 72, 88, 0.13);
//   transform: translateY(-4px) scale(1.02);
//   z-index: 2;
// }

// /* --- Table Hover --- */
// .custom-table tbody tr {
//   transition: background 0.18s;
// }
// .custom-table tbody tr:hover {
//   background: #f0f7ff;
// }

// /* --- Badge and Button Effects --- */
// .badge {
//   transition: background 0.2s, color 0.2s, box-shadow 0.2s;
//   box-shadow: 0 1px 4px rgba(255, 243, 205, 0.18);
// }
// .badge:hover {
//   background: #ffe066;
//   color: #7c5c00;
//   box-shadow: 0 2px 8px rgba(255, 243, 205, 0.28);
// }

// /* --- Score Circle Animation --- */
// .score {
//   animation: popIn 0.7s cubic-bezier(.68,-0.55,.27,1.55) both;
//   transition: box-shadow 0.2s, background 0.2s, color 0.2s;
// }
// .score:hover {
//   box-shadow: 0 4px 16px 0 rgba(46, 125, 50, 0.18);
//   background: #b9f6ca;
//   color: #1b5e20;
// }

// @keyframes popIn {
//   0% { transform: scale(0.7); opacity: 0; }
//   60% { transform: scale(1.15); opacity: 1; }
//   100% { transform: scale(1); opacity: 1; }
// }

// /* --- Section Divider Animation --- */
// .section-divider {
//   width: 100%;
//   height: 3px;
//   background: linear-gradient(90deg, #3f51b5 0%, #ffc107 50%, #4caf50 100%);
//   border: none;
//   margin: 32px 0;
//   opacity: 0.7;
//   animation: fadeInUp 1.2s 0.2s both;
//   border-radius: 2px;
// }

// /* --- Interactive List Items --- */
// .highlight-card ul li {
//   transition: color 0.18s, background 0.18s, padding-left 0.18s;
//   cursor: pointer;
//   border-radius: 4px;
//   padding-left: 0;
// }
// .highlight-card ul li:hover {
//   color: #fff;
//   background: #4caf50;
//   padding-left: 8px;
// }

// /* --- Table Row Animation --- */
// .custom-table tbody tr {
//   animation: fadeInUp 0.7s cubic-bezier(.68,-0.55,.27,1.55) both;
// }

// /* --- Subtle Shadow for Main Wrapper --- */
// .report-wrapper {
//   box-shadow: 0 8px 32px 0 rgba(60, 72, 88, 0.10), 0 1.5px 6px 0 rgba(60, 72, 88, 0.08);
//   transition: box-shadow 0.2s;
// }

// /* --- Responsive: Slight scale on tap for mobile --- */
// @media (hover: none) and (pointer: coarse) {
//   .section-card:active,
//   .highlight-card:active,
//   .score-box:active {
//     transform: scale(0.98);
//   }
// }

// .rank-highlight {
//   background: linear-gradient(135deg, #eef3ff, #dbe5ff);
//   border: 2px solid #a5bdfd;
//   padding: 12px 16px;
//   margin-top: 16px;
//   border-radius: 12px;
//   text-align: center;
//   box-shadow: 0 4px 8px rgba(88, 111, 255, 0.1);
// }

// .rank-label {
//   font-size: 0.9rem;
//   font-weight: 600;
//   color: #4158d0;
//   margin-bottom: 4px;
//   text-transform: uppercase;
//   letter-spacing: 0.05em;
// }

// .rank-value {
//   font-size: 1.5rem;
//   font-weight: 700;
//   color: #2a3cb7;
// }

// .section-card h3 {
//   font-size: 22px;
//   font-weight: 700;
//   color: #333;
//   margin-bottom: 16px;
//   display: flex;
//   align-items: center;
//   gap: 8px;
// }

// .score-box {
//   background: linear-gradient(145deg, #f9f9f9, #ffffff);
//   border: 1px solid #e0e0e0;
//   padding: 20px;
//   border-radius: 12px;
//   box-shadow: 0 2px 8px rgba(0,0,0,0.04);
// }

// .score-box li {
//   padding: 10px 12px;
//   margin-bottom: 10px;
//   border-radius: 8px;
//   background-color: #f4f7fb;
//   border-left: 4px solid #3f51b5;
//   transition: background 0.3s;
//   font-size: 14.5px;
//   color: #333;
// }

// .score-box p {
//   font-size: 14px;
//   /* color: #555; */
//   margin: 6px 0;
//   padding-left: 8px;
//   position: relative;
// }

// .score-box p::before {
//   content: "💡";
//   position: absolute;
//   left: -16px;
//   top: 1px;
// }

// /* Adjust grid spacing */
// .grid.two-col {
//   gap: 32px;
// }

// @media (max-width: 768px) {
//   .grid.two-col {
//     grid-template-columns: 1fr;
//   }
// }

// .section-title-with-icon {
//   display: flex;
//   align-items: center;
//   font-size: 22px;
//   font-weight: 700;
//   color: #333;
//   gap: 10px;
//   margin-bottom: 16px;
// }

// .section-icon {
//   width: 28px;
//   height: 28px;
//   object-fit: contain;
// }

// .box-heading-with-icon {
//   display: flex;
//   align-items: center;
//   gap: 10px;
//   margin-bottom: 20px;
// }

// .box-heading-with-icon h4 {
//   margin: 0;
//   font-size: 18px;
//   font-weight: 600;
//   color: #333;
// }

// .box-icon {
//   width: 24px;
//   height: 24px;
//   object-fit: contain;
// }

// /* SCORE BOX BASE STYLING */
// .score-box {
//   background: linear-gradient(145deg, #f9f9f9, #ffffff);
//   border: 1px solid #e0e0e0;
//   padding: 20px;
//   border-radius: 12px;
//   box-shadow: 0 2px 8px rgba(0,0,0,0.04);
// }

// .score-box:hover {
//   transform: translateY(-4px);
//   box-shadow: 0 8px 24px rgba(60, 72, 88, 0.12);
// }

// .score-box h4 {
//   font-size: 18px;
//   font-weight: 600;
//   color: #2b3d55;
// }

// .score-box ul {
//   list-style: none;
//   padding-left: 0;
//   margin: 0;
// }

// .score-box li {
//   display: flex;
//   align-items: flex-start;
//   gap: 10px;
//   padding: 10px 12px;
//   margin-bottom: 10px;
//   border-radius: 8px;
//   background-color: #f4f7fb;
//   border-left: 4px solid #3f51b5;
//   font-size: 14.5px;
//   color: #333;
//   position: relative;
// }

// .score-box li strong {
//   color: #1a237e;
//   font-weight: 600;
// }

// .score-box li:hover {
//   background-color: #e8efff;
// }

// /* HIGHLIGHT LIST OVERRIDE (for Feedback box) */
// .highlight-list li::before {
//   content: "💡";
//   margin-right: 8px;
//   color: #ffc107;
//   font-size: 16px;
//   line-height: 1;
// }
//             </style>
//           </head>
//           <body>
//             ${content}
//           </body>
//         </html>
//       `);
    
//       printWindow.document.close();
    
//       // Wait for the content to render, then print
//       const interval = setInterval(() => {
//         if (printWindow.document.readyState === 'complete') {
//           clearInterval(interval);
//           // Give the browser some time to apply styles
//           setTimeout(() => {
//             printWindow.focus();
//             printWindow.print();
//             printWindow.close();
//           }, 500);
//         }
//       }, 100);
//     };    

    const handleBrowserPrint2 = () => {
      if (!reportRef.current) return;
    
      // Open a new print window
      const printWindow = window.open('', '_blank', 'width=900,height=800');
    
      if (!printWindow) return;
    
      printWindow.document.write(`
        <html>
          <head>
            <title>Candidate Report</title>
            <link rel="stylesheet" href="/Reports.css" />
            <link rel="stylesheet" href="/CustomPieChart.css" />
          </head>
          <body>
          </body>
        </html>
      `);
    
      printWindow.document.close();
    
      // Wait until the window's DOM is ready
      printWindow.onload = () => {
        // Clone the full DOM node (deep clone)
        const clonedReport = reportRef.current.cloneNode(true);
    
        // Append it to the print window's body
        printWindow.document.body.appendChild(clonedReport);
    
        // Wait a bit for the styles and content to render
        setTimeout(() => {
          printWindow.focus();
          printWindow.print();
          printWindow.close();
        }, 600); // Adjust delay if needed
      };
    };

    const topics = candidate.details.topics.split(',');
    const scores = candidate.details.topics_scores.split(',');

    const formatted = topics.map((topic, idx) => ({
      topic,
      score: scores[idx] ?? null
    }));

    const generateDescription = (topic, score) => {
      if (score >= 8) {
        return `High proficiency in ${topic}`;
      } else if (score >= 6) {
        return `Moderate understanding of ${topic}`;
      } else if (score >= 4) {
        return `Basic familiarity with ${topic}`;
      } else {
        return `Needs improvement in ${topic}`;
      }
    };
    
    const numericScores = candidate.scores.map(item => {
        const [value] = item.score.split('/'); // Get the number before "/"
        return parseInt(value, 10);
    });

    const average = numericScores.reduce((sum, val) => sum + val, 0) / numericScores.length;
    const roundedAverage = Math.round(average);

    const getFitStatus = (score) => {
        if (score >= 75) return 'Strong Fit';
        if (score >= 50) return 'Moderate Fit';
        if (score >= 35) return 'Weak Fit';
        return 'Poor Fit';
      };
    
    const fitStatus = getFitStatus(roundedAverage);

    const getFeedback = (type, score) => {
        const map = {
          pitch: ['Inconsistent', 'Flat', 'Monotonous', 'Uneven', 'Slightly varied', 'Balanced', 'Smooth', 'Calm', 'Consistent', 'Excellent'],
          volume: ['Too low', 'Low', 'Uneven', 'Soft', 'Adequate', 'Clear', 'Strong', 'Bold', 'High', 'Perfect'],
          speechRate: ['Very fast', 'Fast', 'Slightly fast', 'Moderate', 'Balanced', 'Clear', 'Steady', 'Very clear', 'Smooth', 'Perfect'],
          pauses: ['Awkward', 'Too frequent', 'Long', 'Inconsistent', 'Distracting', 'Good', 'Well-placed', 'Natural', 'Great', 'Excellent'],
          grammar: ['Poor', 'Many mistakes', 'Frequent errors', 'Needs improvement', 'Fair', 'Average', 'Good', 'Professional', 'Very good', 'Excellent'],
        };
      
        return map[type]?.[score - 1] || 'N/A';
      };

      const getScoreLabel = (score) => {
        if (score >= 85) return 'Excellent';
        if (score >= 70) return 'Good';
        if (score >= 50) return 'Moderate';
        if (score >= 30) return 'Low';
        return 'Very Low';
      };

      const testInsights = [
          {
            title: (
              <>
                <img
                  src="/technical-support.png"
                  alt="Non Technical Icon"
                  style={{ width: '20px', height: '20px', marginRight: '8px', verticalAlign: 'middle' }}
                />
                Technical Test
              </>
            ),
            strengths: candidate.details.Screening_Strength
              ? candidate.details.Screening_Strength.replace(/[\[\]']+/g, "")
                  .split(",")
                  .map(s => s.trim())
              : [],
            weaknesses: candidate.details.Screening_Weakness
              ? candidate.details.Screening_Weakness.replace(/[\[\]']+/g, "")
                  .split(",")
                  .map(w => w.trim())
              : []
          },
          {
            title: (
              <>
                <img
                  src="/code.png"
                  alt="Non Technical Icon"
                  style={{ width: '20px', height: '20px', marginRight: '8px', verticalAlign: 'middle' }}
                />
                Coding Test
              </>
            ),
            strengths: candidate.details.coding_strengths
              ? candidate.details.coding_strengths.replace(/[\[\]']+/g, "")
                  .split(",")
                  .map(s => s.trim())
              : [],
            weaknesses: candidate.details.coding_weaknesses
              ? candidate.details.coding_weaknesses.replace(/[\[\]']+/g, "")
                  .split(",")
                  .map(w => w.trim())
              : []
          },
          {
            title: (
              <>
                <img
                  src="/mind-map.png"
                  alt="Non Technical Icon"
                  style={{ width: '20px', height: '20px', marginRight: '8px', verticalAlign: 'middle' }}
                />
                Non Technical Test
              </>
            ),
            strengths: [
              ...(candidate.details.Personality_Strength
                ? candidate.details.Personality_Strength.replace(/[\[\]']+/g, "")
                    .split(",")
                    .map(s => s.trim())
                : []),
              ...(candidate.details.Behavioral_Strength
                ? candidate.details.Behavioral_Strength.replace(/[\[\]']+/g, "")
                    .split(",")
                    .map(s => s.trim())
                : [])
            ],
            weaknesses: [
              ...(candidate.details.Personality_Weakness
                ? candidate.details.Personality_Weakness.replace(/[\[\]']+/g, "")
                    .split(",")
                    .map(w => w.trim())
                : []),
              ...(candidate.details.Behavioral_Weakness
                ? candidate.details.Behavioral_Weakness.replace(/[\[\]']+/g, "")
                    .split(",")
                    .map(w => w.trim())
                : [])
            ]
          }              
      ];
      
      const getDescription = (score, trait) => {
        const descriptions = scoreDescriptions[trait];
      
        if (!descriptions) {
          console.warn(`Missing descriptions for trait: ${trait}`);
          return "No description available.";
        }
      
        if (score <= 2) return descriptions[0] || "No description.";
        if (score <= 4) return descriptions[1] || "No description.";
        if (score <= 6) return descriptions[2] || "No description.";
        if (score <= 8) return descriptions[3] || "No description.";
        return descriptions[4] || "No description.";
      };

      const scoreDescriptions = {
        Introversion_vs_Extroversion: [
          "Very reserved, avoids social interaction, prefers solo tasks.",
          "Introverted, participates when needed but prefers quiet environments.",
          "Moderately outgoing, balances group and individual work.",
          "Confident communicator, active in discussions, energizes team.",
          "Highly extroverted, thrives in social settings, natural leader and speaker."
        ],
        Emotional_Stability: [
          "Easily stressed, anxious in high-pressure situations.",
          "Sensitive to criticism, may show emotional fluctuation.",
          "Generally calm but can be reactive under prolonged stress.",
          "Emotionally composed, handles stress and criticism well.",
          "Exceptionally calm and resilient, maintains stability in any situation."
        ],
        Openness_to_Experience: [
          "Prefers routine and tradition, resistant to new ideas.",
          "Cautious toward change, prefers familiar systems.",
          "Open to ideas with some reservation; evaluates change before adoption.",
          "Curious and imaginative, embraces new perspectives and tools.",
          "Highly innovative and experimental, eager to explore the unknown."
        ],
        Agreeableness: [
          "Competitive or critical, may cause interpersonal friction.",
          "Occasionally cooperative but may struggle with empathy.",
          "Reasonably cooperative and understanding in most cases.",
          "Empathetic, promotes harmony and helps resolve conflicts.",
          "Highly compassionate and generous, promotes strong team bonding."
        ],
        Conscientiousness: [
          "Unorganized, often misses deadlines or details.",
          "Needs guidance and structure to stay on task.",
          "Generally responsible, but may need supervision.",
          "Reliable, organized, self-motivated to complete tasks.",
          "Extremely detail-oriented, proactive, sets high personal standards."
        ],
        Problem_Solving: [
          "Struggles to identify issues and find solutions independently.",
          "Occasionally identifies problems, but needs support solving them.",
          "Able to solve familiar problems with some guidance.",
          "Effectively analyzes problems and generates practical solutions.",
          "Highly analytical, proactive problem-solver with strategic thinking."
        ],
        Communication_Skills: [
          "Has difficulty expressing ideas clearly and listening effectively.",
          "Can communicate basic points but may lack clarity or engagement.",
          "Communicates clearly in routine situations, sometimes persuasive.",
          "Effectively conveys complex ideas and listens actively.",
          "Exceptional communicator, inspires and connects with diverse audiences."
        ],
        Handling_Pressure: [
          "Struggles to maintain performance in stressful situations.",
          "Shows signs of stress under pressure, may need frequent support.",
          "Can perform under pressure with occasional lapses.",
          "Remains composed and focused in challenging situations.",
          "Thrives under pressure, demonstrates resilience and high performance."
        ],
        Ownership_and_Responsibility: [
          "Avoids accountability, often shifts blame or neglects duties.",
          "Reluctant to take ownership, requires close supervision.",
          "Takes responsibility for assigned work with some follow-through.",
          "Demonstrates strong ownership, meets commitments reliably.",
          "Fully accountable, proactive in taking initiative and responsibility."
        ],
        Values_and_Ethics: [
          "Disregards ethical standards, makes decisions for personal gain.",
          "Sometimes compromises values under pressure or influence.",
          "Generally ethical but may need reminders or guidance.",
          "Strong sense of integrity, adheres to company and personal ethics.",
          "Highly principled, consistently demonstrates integrity and fairness."
        ],
        efficiency: [
          "Code is inefficient and overly complex, with many redundancies.",
          "Basic understanding of optimization, but code is often slow or poorly structured.",
          "Moderately efficient, uses some optimization techniques but lacks consistency.",
          "Mostly efficient and optimized, with minimal unnecessary complexity.",
          "Highly efficient and elegant code, consistently optimized for performance and clarity."
        ],
        performance: [
          "Code frequently causes bottlenecks or fails under real-world load.",
          "Below-average performance; optimization is often overlooked.",
          "Meets general performance standards, but lacks advanced tuning.",
          "Performs well under normal and high loads, optimized for speed.",
          "Exceptionally high-performing code, optimized across edge cases and large-scale use."
        ],
        robustness: [
          "Code breaks easily and lacks error handling or failsafe mechanisms.",
          "Occasionally handles errors, but reliability is limited.",
          "Reasonably robust with basic error handling and input validation.",
          "Reliable under varied conditions; anticipates edge cases and errors.",
          "Extremely robust, handles unexpected inputs and edge cases gracefully."
        ],
        readability_score: [
          "Poorly structured, hard to read or maintain; lacks comments and clarity.",
          "Readable in parts but inconsistent formatting and structure.",
          "Average readability with standard naming and structure.",
          "Clean and well-organized, with meaningful naming and consistent formatting.",
          "Highly readable and maintainable, with excellent structure and documentation."
        ],
        correctness: [
          "Code fails to meet requirements and contains frequent bugs.",
          "Partially correct, often needs revision or debugging.",
          "Mostly correct, meets functional requirements with minor issues.",
          "Functionally correct with high test pass rate and few bugs.",
          "Fully correct, adheres to all specifications and passes all edge cases and tests flawlessly."
        ]
      };

      const traits = [
        { key: 'Introversion_vs_Extroversion', label: 'Extroversion' },
        { key: 'Emotional_Stability', label: 'Emotional Stability' },
        { key: 'Openness_to_Experience', label: 'Openness to Experience' },
        { key: 'Agreeableness', label: 'Agreeableness' },
        { key: 'Conscientiousness', label: 'Conscientiousness' }
      ];

      const traits_behavioral = [
        { key: 'Problem_Solving', label: 'Problem Solving' },
        { key: 'Communication_Skills', label: 'Communication Skills' },
        { key: 'Handling_Pressure', label: 'Handling Pressure' },
        { key: 'Ownership_and_Responsibility', label: 'Ownership and Responsibility' },
        { key: 'Values_and_Ethics', label: 'Values and Ethics' }
      ];  

    return (
        <div className={cn("min-h-screen bg-background")}>
            <Navbar />
            <Hero />

            <Container className={cn("py-4")}>
              <div className={cn("flex justify-end mb-4")}>
                <Button onClick={handleBrowserPrint2} variant="outline">
                  <Download className={cn("w-4 h-4 mr-2")} />
                  Download Report as PDF
                </Button>
              </div>

              <Card className={cn("max-w-6xl mx-auto")} ref={reportRef}>
                <CardContent className={cn("p-6 md:p-8")}>
                  <header className={cn("flex flex-col md:flex-row justify-between items-start md:items-center gap-6 mb-8 pb-6 border-b")}>
                      <div>
                          <Heading level="h1" className={cn("text-3xl font-bold mb-2")}>{candidate.details.name}</Heading>
                          <Heading level="h2" className={cn("text-xl text-muted-foreground")}>{jobDetails.job_title}</Heading>
                      </div>

                      {/* Emphasized Rank Display */}
                      <div className={cn("px-4 py-3 bg-gradient-to-br from-blue-50 to-indigo-50 border-2 border-blue-200 rounded-lg text-center shadow-sm")}>
                          <Text className={cn("text-xs font-semibold text-blue-700 uppercase tracking-wide mb-1")}>Candidate Rank</Text>
                          <Text className={cn("text-2xl font-bold text-blue-900")}>
                              <strong>{candidate.rank}</strong> / {candidate.total_results}
                          </Text>
                      </div>

                      {/* Score Badge */}
                      <div className={cn("flex flex-col items-center")}>
                          <div className={cn("w-20 h-20 rounded-full bg-green-100 text-green-700 text-2xl font-bold flex items-center justify-center mb-2")}>
                              {roundedAverage}%
                          </div>
                          <span className={cn("px-3 py-1 text-xs font-medium bg-yellow-100 text-yellow-800 rounded")}>{fitStatus}</span>
                      </div>

                      {/* Summary Block */}
                      <div className={cn("p-4 bg-gradient-to-br from-gray-50 to-white border rounded-lg shadow-sm min-w-[240px]")}>
                          <div className={cn("flex justify-between items-center mb-3 pb-2 border-b border-dashed")}>
                              <Text className={cn("text-sm font-semibold text-gray-700")}>Current CTC:</Text>
                              <Text className={cn("text-sm")}>26 LPA</Text>
                          </div>
                          <div className={cn("flex justify-between items-center mb-3 pb-2 border-b border-dashed")}>
                              <Text className={cn("text-sm font-semibold text-gray-700")}>Expected CTC:</Text>
                              <Text className={cn("text-sm")}>32 LPA</Text>
                          </div>
                          <div className={cn("flex justify-between items-center")}>
                              <Text className={cn("text-sm font-semibold text-gray-700")}>Notice Period:</Text>
                              <Text className={cn("text-sm")}>60 Days</Text>
                          </div>
                      </div>
                  </header>

                  <main className={cn("space-y-8")}>
                    <Card className={cn("p-6")}>
                      <CardContent className={cn("p-0")}>
                        <div className={cn("grid md:grid-cols-2 gap-6")}>
                          <div>
                            <Heading level="h3" className={cn("text-xl font-semibold mb-4")}>📝 Summary</Heading>
                            <Text>{candidate.details.Overall_Summary}</Text>
                          </div>
                          <div>
                            <CustomPieChart scores={candidate.details} />
                          </div>
                        </div>
                      </CardContent>
                    </Card>

                    <hr className={cn("border-t border-border")} />
                    
                    <Card className={cn("p-6")}>
                      <CardContent className={cn("p-0")}>
                        <div className={cn("flex items-center gap-3 mb-6")}>
                          <img src="/ai.png" alt="AI Icon" className={cn("w-7 h-7")} />
                          <Heading level="h3" className={cn("text-2xl font-bold")}>AI Interview Scorecard</Heading>
                        </div>
                        <div className={cn("grid md:grid-cols-3 gap-6")}>
                          <Card className={cn("p-4")}>
                            <CardContent className={cn("p-0")}>
                              <div className={cn("flex items-center gap-2 mb-4")}>
                                <img src="/metrics.png" alt="AI Metrics" className={cn("w-6 h-6")} />
                                <Heading level="h4" className={cn("text-lg font-semibold")}>AI Evaluation Metrics</Heading>
                              </div>
                              <ul className={cn("space-y-2")}>
                                <li className={cn("text-sm")}><strong>Overall AI Score:</strong> {roundedAverage}% – {getScoreLabel(roundedAverage)}</li>
                                <li className={cn("text-sm")}><strong>Screening Test Score:</strong> {candidate.details.screening_score}% – {getScoreLabel(candidate.details.screening_score)}</li>
                                <li className={cn("text-sm")}><strong>Domain Score:</strong> {candidate.details.domain_score}% – {getScoreLabel(candidate.details.domain_score)}</li>
                                <li className={cn("text-sm")}><strong>Confidence Level:</strong> {candidate.details.confidence_score}% – {getScoreLabel(candidate.details.confidence_score)}</li>
                                <li className={cn("text-sm")}><strong>Resume Score:</strong> {candidate.details.Resume_Score}% – {getScoreLabel(candidate.details.Resume_Score)}</li>
                              </ul>
                            </CardContent>
                          </Card>

                          <Card className={cn("p-4")}>
                            <CardContent className={cn("p-0")}>
                              <div className={cn("flex items-center gap-2 mb-4")}>
                                <img src="/code.png" alt="Highlights" className={cn("w-6 h-6")} />
                                <Heading level="h4" className={cn("text-lg font-semibold")}>Coding Test Evaluation</Heading>
                              </div>
                              <ul className={cn("space-y-2")}>
                                <li className={cn("text-sm")}><strong>Code Efficiency:</strong> {candidate.details.efficiency}% – {getScoreLabel(candidate.details.efficiency)}</li>
                                <li className={cn("text-sm")}><strong>Code Performance:</strong> {candidate.details.performance}% – {getScoreLabel(candidate.details.performance)}</li>
                                <li className={cn("text-sm")}><strong>Robustness:</strong> {candidate.details.robustness}% – {getScoreLabel(candidate.details.robustness)}</li>
                                <li className={cn("text-sm")}><strong>Code Readability & Structure:</strong> {candidate.details.readability_score}% – {getScoreLabel(candidate.details.readability_score)}</li>
                                <li className={cn("text-sm")}><strong>Code Correctness:</strong> {candidate.details.correctness}% – {getScoreLabel(candidate.details.correctness)}</li>
                              </ul>
                            </CardContent>
                          </Card>
                          
                          <Card className={cn("p-4")}>
                            <CardContent className={cn("p-0")}>
                              <Heading level="h4" className={cn("text-lg font-semibold mb-4")}>🎙️ Audio/Visual Feedback</Heading>
                              <ul className={cn("space-y-2")}>
                                <li className={cn("text-sm")}><strong>Pitch:</strong> {getFeedback('pitch', candidate.details.Pitch)} ({candidate.details.Pitch}/10)</li>
                                <li className={cn("text-sm")}><strong>Volume:</strong> {getFeedback('volume', candidate.details.Volume)} ({candidate.details.Volume}/10)</li>
                                <li className={cn("text-sm")}><strong>Speech Rate:</strong> {getFeedback('speechRate', candidate.details.rate)} ({candidate.details.rate}/10)</li>
                                <li className={cn("text-sm")}><strong>Pauses:</strong> {getFeedback('pauses', candidate.details.Pauses)} ({candidate.details.Pauses}/10)</li>
                                <li className={cn("text-sm")}><strong>Grammar:</strong> {getFeedback('grammar', candidate.details.Grammar_Score)} ({candidate.details.Grammar_Score}/10)</li>
                              </ul>
                            </CardContent>
                          </Card>
                        </div>
                      </CardContent>
                    </Card>
                    
                    <hr className={cn("border-t border-border my-8")} />
                    
                    <div className={cn("grid md:grid-cols-2 gap-6")}>
                      <Card className={cn("p-6 bg-green-50 border-green-200")}>
                        <CardContent className={cn("p-0")}>
                          <Heading level="h3" className={cn("text-xl font-semibold mb-4 text-green-800")}>✅ Strengths</Heading>
                          {testInsights.map((test, idx) => (
                            <div key={idx} className={cn("mb-4 mt-4")}>
                              <Text className={cn("font-semibold mb-2")}>{test.title}</Text>
                              <ul className={cn("list-disc list-inside space-y-1 mt-2")}>
                                {test.strengths.map((point, i) => (
                                  <li key={i} className={cn("text-sm")}>{point}</li>
                                ))}
                              </ul>
                            </div>
                          ))}
                        </CardContent>
                      </Card>

                      <Card className={cn("p-6 bg-red-50 border-red-200")}>
                        <CardContent className={cn("p-0")}>
                          <Heading level="h3" className={cn("text-xl font-semibold mb-4 text-red-800")}>❌ Weaknesses</Heading>
                          {testInsights.map((test, idx) => (
                            <div key={idx} className={cn("mb-4 mt-4")}>
                              <Text className={cn("font-semibold mb-2")}>{test.title}</Text>
                              <ul className={cn("list-disc list-inside space-y-1 mt-2")}>
                                {test.weaknesses.map((point, i) => (
                                  <li key={i} className={cn("text-sm")}>{point}</li>
                                ))}
                              </ul>
                            </div>
                          ))}
                        </CardContent>
                      </Card>
                    </div>

                    <hr className={cn("border-t border-border my-8")} />
                    
                    <Card className={cn("p-6")}>
                      <CardContent className={cn("p-0")}>
                        <Heading level="h3" className={cn("text-2xl font-bold mb-6")}>📊 AI Evaluation – Detailed Test Breakdown</Heading>

                        <div className={cn("mb-6")}>
                          <div className={cn("flex items-center gap-2 mb-4")}>
                            <img src="/technical-support.png" alt="Technical Icon" className={cn("w-6 h-6")} />
                            <Heading level="h4" className={cn("text-lg font-semibold")}>Technical Evaluation</Heading>
                          </div>
                          <div className={cn("overflow-x-auto")}>
                            <table className={cn("min-w-full border-collapse border border-border")}>
                              <thead className={cn("bg-muted")}>
                                <tr>
                                  <th className={cn("border border-border px-4 py-2 text-left text-sm font-semibold")}>Section</th>
                                  <th className={cn("border border-border px-4 py-2 text-left text-sm font-semibold")}>Description</th>
                                  <th className={cn("border border-border px-4 py-2 text-left text-sm font-semibold")}>Score (out of 10)</th>
                                </tr>
                              </thead>
                              <tbody>
                                {formatted.map((item, idx) => (
                                  <tr key={idx} className={cn("hover:bg-muted/50")}>
                                    <td className={cn("border border-border px-4 py-2 text-sm")}>{item.topic}</td>
                                    <td className={cn("border border-border px-4 py-2 text-sm")}>{generateDescription(item.topic, item.score)}</td>
                                    <td className={cn("border border-border px-4 py-2 text-sm")}>{item.score}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>

                        <div>
                          <div className={cn("flex items-center gap-2 mb-4")}>
                            <img src="/mind-map.png" alt="Non-Technical Icon" className={cn("w-6 h-6")} />
                            <Heading level="h4" className={cn("text-lg font-semibold")}>Non-Technical Evaluation</Heading>
                          </div>
                          <div className={cn("overflow-x-auto")}>
                            <table className={cn("min-w-full border-collapse border border-border")}>
                              <thead className={cn("bg-muted")}>
                                <tr>
                                  <th className={cn("border border-border px-4 py-2 text-left text-sm font-semibold")}>Trait</th>
                                  <th className={cn("border border-border px-4 py-2 text-left text-sm font-semibold")}>Description</th>
                                  <th className={cn("border border-border px-4 py-2 text-left text-sm font-semibold")}>Score (out of 10)</th>
                                </tr>
                              </thead>
                              <tbody>
                                {[...traits_behavioral, ...traits].map(({ key, label }) => {
                                  const score = candidate.details[key];
                                  return (
                                    <tr key={key} className={cn("hover:bg-muted/50")}>
                                      <td className={cn("border border-border px-4 py-2 text-sm")}>{label}</td>
                                      <td className={cn("border border-border px-4 py-2 text-sm")}>{getDescription(score, key)}</td>
                                      <td className={cn("border border-border px-4 py-2 text-sm")}>{score}</td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </CardContent>
                    </Card>

                    <hr className={cn("border-t border-border my-8")} />
                    
                    <Card className={cn("p-6")}>
                      <CardContent className={cn("p-0")}>
                        <div className={cn("flex items-center gap-2 mb-6")}>
                          <span className={cn("text-2xl")}>💻</span>
                          <Heading level="h3" className={cn("text-2xl font-bold")}>Deep Code Analysis</Heading>
                        </div>

                        <Card className={cn("p-4 mb-4")}>
                          <CardContent className={cn("p-0")}>
                            <div className={cn("flex items-center gap-3 mb-4")}>
                              <span className={cn("text-xl")}>📋</span>
                              <Heading level="h4" className={cn("text-lg font-semibold")}>Code Summary</Heading>
                            </div>
                            <div>
                              {candidate.details?.coding_summary ? (
                                <ul className={cn("list-disc list-inside space-y-1")}>
                                  {candidate.details.coding_summary.split(',').map((point, index) => (
                                    <li key={index} className={cn("text-sm")}>{point.trim()}</li>
                                  ))}
                                </ul>
                              ) : (
                                <Text>No summary available</Text>
                              )}
                            </div>
                          </CardContent>
                        </Card>

                        {candidate.details?.plagiarism_percentage && (
                          <Card className={cn("p-4 mb-4", parseInt(candidate.details.plagiarism_percentage) > 40 ? 'bg-red-50 border-red-200' : 'bg-green-50 border-green-200')}>
                            <CardContent className={cn("p-0")}>
                              <div className={cn("flex items-center gap-3 mb-4")}>
                                <span className={cn("text-xl")}>
                                  {parseInt(candidate.details.plagiarism_percentage) > 40 ? '⚠️' : '✅'}
                                </span>
                                <Heading level="h4" className={cn("text-lg font-semibold")}>Plagiarism Check</Heading>
                              </div>
                              <div className={cn("mb-4")}>
                                <div className={cn("relative h-6 bg-gray-200 rounded-full overflow-hidden")}>
                                  <div 
                                    className={cn("h-full rounded-full", parseInt(candidate.details.plagiarism_percentage) > 40 ? 'bg-red-500' : 'bg-green-500')}
                                    style={{ width: `${Math.min(100, parseInt(candidate.details.plagiarism_percentage))}%` }}
                                  ></div>
                                  <span className={cn("absolute inset-0 flex items-center justify-center text-xs font-semibold text-black")}>
                                    {candidate.details.plagiarism_percentage}% Similarity
                                  </span>
                                </div>
                                <Text className={cn("text-sm mt-2", parseInt(candidate.details.plagiarism_percentage) > 40 ? 'text-red-700' : 'text-green-700')}>
                                  {parseInt(candidate.details.plagiarism_percentage) > 40 ? (
                                    'Significant code similarity detected that requires review'
                                  ) : (
                                    'Minimal code similarity detected'
                                  )}
                                </Text>
                              </div>
                            </CardContent>
                          </Card>
                        )}
                      
                        <div className={cn("grid md:grid-cols-3 gap-4")}>
                          <Card className={cn("p-4")}>
                            <CardContent className={cn("p-0")}>
                              <div className={cn("flex items-center gap-3 mb-4")}>
                                <span className={cn("text-xl")}>🏗️</span>
                                <Heading level="h4" className={cn("text-lg font-semibold")}>Code Architecture</Heading>
                              </div>
                              {candidate.details?.code_architecture ? (
                                <ul className={cn("list-disc list-inside space-y-1")}>
                                  {candidate.details.code_architecture.split('\n').map((point, index) => (
                                    <li key={index} className={cn("text-sm")}>{point.trim()}</li>
                                  ))}
                                </ul>
                              ) : (
                                <Text>No architecture analysis available</Text>
                              )}
                            </CardContent>
                          </Card>
                          
                          <Card className={cn("p-4")}>
                            <CardContent className={cn("p-0")}>
                              <div className={cn("flex items-center gap-3 mb-4")}>
                                <span className={cn("text-xl")}>⚡</span>
                                <Heading level="h4" className={cn("text-lg font-semibold")}>Performance Optimization</Heading>
                              </div>
                              {candidate.details?.performance_optimization ? (
                                <ul className={cn("list-disc list-inside space-y-1")}>
                                  {candidate.details.performance_optimization.split('\n').map((point, index) => (
                                    <li key={index} className={cn("text-sm")}>{point.trim()}</li>
                                  ))}
                                </ul>
                              ) : (
                                <Text>No performance optimization analysis available</Text>
                              )}
                            </CardContent>
                          </Card>
                          
                          <Card className={cn("p-4")}>
                            <CardContent className={cn("p-0")}>
                              <div className={cn("flex items-center gap-3 mb-4")}>
                                <span className={cn("text-xl")}>🧠</span>
                                <Heading level="h4" className={cn("text-lg font-semibold")}>Algorithm Selection</Heading>
                              </div>
                              {candidate.details?.algorithm_selection ? (
                                <ul className={cn("list-disc list-inside space-y-1")}>
                                  {candidate.details.algorithm_selection.split('\n').map((point, index) => (
                                    <li key={index} className={cn("text-sm")}>{point.trim()}</li>
                                  ))}
                                </ul>
                              ) : (
                                <Text>No algorithm selection analysis available</Text>
                              )}
                            </CardContent>
                          </Card>
                        </div>
                      </CardContent>
                    </Card>
                  </main>
                </CardContent>
              </Card>
            </Container>
            <Footer />
        </div>
    );
};

export default Reports;